import React from "react"
import { Chip, IconButton, FontIcon } from "material-ui"
import autobind from "class-autobind"
import { IUserRole } from "../../models"
import strings from "../../localization/strings"
import AccountStore from "../../stores/AccountStore"
import _ from "lodash"
import AddRoleDialogForChip from "./AddRoleDialogForChip"

interface IProps {
    readonly: boolean
    label: string
    selectedRoleIds: string[]
    error?: string
    hideLabel?: boolean
    handleChange?(selectedRoleIds: string[]): void
}
interface IState {
    selectedRoleIds: string[]
    openAddRoleDialog: boolean
    roles: IUserRole[]
}

export default class MultiUserRoleChips extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            selectedRoleIds: this.props.selectedRoleIds,
            openAddRoleDialog: false,
            roles: AccountStore.getCurrentAccountSettings().UserRoles || [],
        }
        autobind(this)
    }

    getRole(roleId) {
        return this.state.roles.find(role => role.Id === roleId);
    }

    render() {
        return (
            <div>
                {!this.props.hideLabel &&
                    <div>
                        <span>{this.props.label}</span>
                        <span style={{ color: "rgb(244, 67, 54)", fontSize: 12, marginLeft: 15 }}>{this.props.error}</span>
                    </div>
                }
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                    {   
                        this.state.selectedRoleIds.map(roleId =>
                            <Chip
                                key={roleId}
                                style={{ margin: 5, cursor: "pointer" }}
                                onRequestDelete={
                                    () => {
                                        this.state.selectedRoleIds.splice(this.state.selectedRoleIds.indexOf(roleId), 1);
                                        this.setState({selectedRoleIds: this.state.selectedRoleIds})
                                        this.props.handleChange(this.state.selectedRoleIds)
                                    }}
                            >
                                {this.getRole(roleId).Type}
                            </Chip>
                        )
                    }

                    {!this.props.readonly &&
                        <IconButton
                            style={{ height: 35, width: 35, padding: 0, margin: 0, display: "inline-block" }}
                            onTouchTap={() => this.setState({ openAddRoleDialog: true })}
                        >
                            <FontIcon className="fa fa-plus-circle" />
                        </IconButton>
                    }
                </div>
                {this.state.openAddRoleDialog &&
                
                    <AddRoleDialogForChip
                        selectedRoleIds={this.state.selectedRoleIds}
                        handleClose={() => this.setState({ openAddRoleDialog: false })}
                        handleUpdate={roleIds => {
                            this.setState({selectedRoleIds: roleIds, openAddRoleDialog: false})
                            this.props.handleChange(this.state.selectedRoleIds)
                        }}
                    />                    
                }
            </div>
        )
    }
}